
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as rF_d_xG_45Zx3Fh5UjhFuQ1mkpe57Ff3lI07bIfG_45D33KwMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/r.vue?macro=true";
import { default as indextsxIN9qigqISQJfuBI2kB_S24aSd5UjcupJG7AqPYX8Meta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/index.vue?macro=true";
import { default as follow_45WFu9TDp9GwVCY1XHp0TCrvARmll9C0hYRGT6hPkCoIMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/follow.vue?macro=true";
import { default as logoutO6gYeFU_ilHTbyMfXCdq7_45ELMcNaZ3zj_45Y5dPqZM_pYMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/logout.vue?macro=true";
import { default as sessionHSasAEfxpn1mwEcGCIwbnxR5uVNf6ieJu00x9UA3U3YMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/session.vue?macro=true";
import { default as indexNcitRqGqwiun9OcoUaHFzc1_45JRr2IxnsOLdqZ5QzBAcMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/index.vue?macro=true";
import { default as rawId6WSwBiDM3BYQ9buUDW_paZWWQLg1GWT0M_45G9r1_TCxQMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/rawId.vue?macro=true";
import { default as tokenC7HtnO8TOmfhAn2qgHl8jTkPclw_45l5cBE1PHoYTkgOsMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/token.vue?macro=true";
import { default as indexCNiMdPl2PfUC8D9XzAQnNs7M_lzDrmNwNzzfS89GxY4Meta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/enquete/[guid]/index.vue?macro=true";
import { default as EnqueteRequiredCt_45b3rQsDM4foDWfQrJ0V4odAd4LBXl4HqQHTbaiiHkMeta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/enquete/[guid]/EnqueteRequired.vue?macro=true";
import { default as _91lineActivationProviderId_933GSCPxGWzQsmqLG1TRQP_45KM58_45zAHigslCPaas8Mdq4Meta } from "/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId].vue?macro=true";
export default [
  {
    name: _91lineActivationProviderId_933GSCPxGWzQsmqLG1TRQP_45KM58_45zAHigslCPaas8Mdq4Meta?.name,
    path: "/providers/:lineActivationProviderId()",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId].vue"),
    children: [
  {
    name: "providers-lineActivationProviderId-r",
    path: "r",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/r.vue")
  },
  {
    name: "providers-lineActivationProviderId",
    path: "",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/index.vue")
  },
  {
    name: "providers-lineActivationProviderId-follow",
    path: "follow",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/follow.vue")
  },
  {
    name: "providers-lineActivationProviderId-logout",
    path: "logout",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/logout.vue")
  },
  {
    name: "providers-lineActivationProviderId-session",
    path: "session",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/session.vue")
  },
  {
    name: "providers-lineActivationProviderId-login-link",
    path: "login-link",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/index.vue")
  },
  {
    name: "providers-lineActivationProviderId-login-link-rawId",
    path: "login-link/rawId",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/rawId.vue")
  },
  {
    name: "providers-lineActivationProviderId-login-link-token",
    path: "login-link/token",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/login-link/token.vue")
  },
  {
    name: "providers-lineActivationProviderId-enquete-guid",
    path: "enquete/:guid()",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/enquete/[guid]/index.vue")
  },
  {
    name: "providers-lineActivationProviderId-enquete-guid-EnqueteRequired",
    path: "enquete/:guid()/EnqueteRequired",
    component: () => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/pages/providers/[lineActivationProviderId]/enquete/[guid]/EnqueteRequired.vue")
  }
]
  }
]